import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import PageHero from '../components/PageHero';
import ServiceSections from '../components/ServiceSections';
import ServicesSidebar from '../components/ServicesSidebar';
import BusinessPotentialSection from '../components/BusinessPotentialSection';
import servicesData from '../data/services.json';

const Services = () => {
  const { serviceType } = useParams();
  const [serviceContent, setServiceContent] = useState<any>({});

  useEffect(() => {
    const content = servicesData[serviceType as keyof typeof servicesData];
    setServiceContent(content);
  }, [serviceType]);

  return (
    <>
      {serviceContent && (
        <>
          <PageHero
            backgroundImage={serviceContent.backgroundImage}
            title={serviceContent.title}
            subtitle={serviceContent.subtitle}
            description={serviceContent.description}
            breadcrumb={{
              home: "Home",
              current: "Services"
            }}
          />
          {serviceContent.sections && (
            <section className="py-5">
              <Container>
                <Row>
                  <Col lg={8} className="mb-4">
                    <ServiceSections sections={serviceContent.sections} />
                  </Col>
                  <Col lg={4}>
                    <ServicesSidebar />
                  </Col>
                </Row>
              </Container>
            </section>
          )}
          <BusinessPotentialSection />
        </>
      )}
    </>
  );
};

export default Services; 